module.exports = __webpack_public_path__ + "img/EESTEC.945b8dd2.png";